import { Tenant } from 'src/types/enums';

import { rootApi } from '../rootApi';
import { HTTPRequestType } from '../api.types';
import { Language, TermsOfServiceResponse, TypeDefinitionsResponse } from './system.types';

export interface RequestTermsOfServiceParams {
  type: string;
  target?: Tenant;
  region?: string;
}

export const systemApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenantTerms: builder.query<TermsOfServiceResponse, RequestTermsOfServiceParams>({
      query: (params: RequestTermsOfServiceParams) => ({
        url: `/system/user-terms/current?type=${params.type}${
          params.region ? `&region=${params.region}` : ''
        }${params.target ? `&target=${params.target}` : ''}`,
        method: HTTPRequestType.GET,
      }),
    }),
    getTypeDefinitions: builder.query<TypeDefinitionsResponse, void>({
      query: () => ({
        url: '/system/type-definitions/enums',
        method: HTTPRequestType.GET,
      }),
    }),

    getLanguages: builder.query<Language[], void>({
      query: () => ({
        url: '/languages',
      }),
    }),
  }),
});

export const { useGetTenantTermsQuery, useGetTypeDefinitionsQuery, useGetLanguagesQuery } =
  systemApi;
